/* Zabi FAQ — live zoekfilter (terwijl je typt) + categorie-tabs. Puur client-side. */
(function () {
  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function esc(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(root) {
    if (!root || root.dataset.faqReady) return;
    root.dataset.faqReady = '1';

    var input = root.querySelector('.zabi-faq__search input');
    var list = root.querySelector('.zabi-faq__list');
    var items = [].slice.call(root.querySelectorAll('.zabi-faq__item'));
    var tabs = [].slice.call(root.querySelectorAll('.zabi-faq__tab'));
    if (!list || !items.length) return;

    var empty = document.createElement('p');
    empty.className = 'zabi-faq__empty';
    empty.hidden = true;
    empty.textContent = 'Geen vragen gevonden. Probeer een ander zoekwoord.';
    list.parentNode.insertBefore(empty, list.nextSibling);

    var data = items.map(function (el) {
      var q = el.querySelector('.zabi-faq__question');
      var a = el.querySelector('.zabi-faq__answer');
      var qText = q ? q.textContent : '';
      return { el: el, q: q, qText: qText, cat: el.getAttribute('data-cat') || '', hay: norm(qText + ' ' + (a ? a.textContent : '')) };
    });

    var activeCat = ''; // leeg = alle
    var t;

    function highlight(d, raw) {
      if (!d.q) return;
      if (!raw) { d.q.textContent = d.qText; return; }
      var lc = d.qText.toLowerCase();
      var idx = lc.indexOf(raw.toLowerCase());
      if (idx === -1) { d.q.textContent = d.qText; return; }
      d.q.innerHTML = esc(d.qText.slice(0, idx)) +
        '<mark class="zabi-faq__hl">' + esc(d.qText.slice(idx, idx + raw.length)) + '</mark>' +
        esc(d.qText.slice(idx + raw.length));
    }

    function apply() {
      var raw = input ? input.value.trim() : '';
      var query = norm(raw);
      var shown = 0;
      data.forEach(function (d) {
        var okCat = !activeCat || d.cat === activeCat;
        var okQuery = !query || d.hay.indexOf(query) !== -1;
        var show = okCat && okQuery;
        d.el.style.display = show ? '' : 'none';
        if (show) { shown++; highlight(d, query ? raw : ''); }
        else if (d.q) { d.q.textContent = d.qText; }
      });
      empty.hidden = shown !== 0;
    }

    if (input) {
      input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(apply, 110); });
      input.addEventListener('search', apply);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('zabi-faq__tab--active'); });
        tab.classList.add('zabi-faq__tab--active');
        activeCat = tab.getAttribute('data-cat') || '';
        apply();
      });
    });
  }

  function boot() { [].forEach.call(document.querySelectorAll('.zabi-faq'), init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.zabi-faq');
    if (r) init(r);
  });
})();
